import { getCasinoProviderUrl } from '../../adapters/casino'
import { EnvConfig } from '../../config/EnvConfig'
import { GamesLanguages } from '../constants'
import { convertOptionsToQueryParams } from './generateURL'
import { getMockURL } from './mockURL'

const locale = process.env.GATSBY_INTL_LOCALE
const language = GamesLanguages?.ISO6391?.[locale]
const lobbyUrl = EnvConfig.SITE_URL

export const setHub88URL = async ({
  slug,
  isMobile,
  desktopSlug,
  mobileSlug,
  isLoggedIn,
  depositUrl,
  casinoProvider,
  playerId,
  isMock,
  providerSlug,
}) => {
  const providerLowerCase = casinoProvider?.toLowerCase()
  const status = isLoggedIn ? 'launch' : 'demo'

  const getLanguage = () => {
    if (providerSlug === 'bgaming' && language === 'pt') {
      return 'pt-BR'
    }

    if (providerSlug === 'Fantasma' && language === 'pt') {
      return 'pt_BR'
    }

    return language || 'en'
  }

  const options = [
    {
      param: 'game',
      value: slug,
    },
    {
      param: 'platform',
      value: isMobile ? mobileSlug : desktopSlug,
    },
    {
      param: 'lang',
      value: getLanguage(),
    },
    {
      param: 'lobbyUrl',
      value: lobbyUrl,
    },
    {
      param: 'depositUrl',
      value: depositUrl,
    },
    {
      param: 'user',
      value: playerId,
    },
  ]

  const params = convertOptionsToQueryParams(options)

  if (isMock) {
    return getMockURL({
      path: 'launch',
      params,
      casinoProvider,
    })
  }

  const path = `/casino/providers/${providerLowerCase}/${status}/${params}`
  const { data, ok } = await getCasinoProviderUrl(path)

  if (ok) {
    const { url } = data
    return url
  }

  return null
}
